import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import InternetExplorerWarning from './internet-explorer-warning';
import * as serviceWorker from './serviceWorker';
import Routes from './routes';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import Auth from './auth/auth';
import './auth/fetchInterceptor';

const LAUNCH_DARKLY_CLIENTSIDE_ID =
  window.env.REACT_APP_LAUNCH_DARKLY_CLIENTSIDE_ID || '';

const profile = new Auth().getProfile();
const LDProvider = await asyncWithLDProvider({
  clientSideID: LAUNCH_DARKLY_CLIENTSIDE_ID,
  context: {
    kind: 'user',
    key: profile?.name || 'default-user',
    email: profile?.email || 'default-email',
  },
});

const browserIsIE = () =>
  !!navigator.userAgent.match(/Trident/g) ||
  !!navigator.userAgent.match(/MSIE/g);

const componentToRender = browserIsIE() ? (
  <InternetExplorerWarning />
) : (
  <LDProvider>
    <Routes />
  </LDProvider>
);

ReactDOM.render(componentToRender, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
export { copyAdjustmentsFromWorkspace } from './adjustmentHelper';
export { mapUnsavedValuesForProposalCalc } from './adjustmentHelper';
export { mapSavedValuesForProposalCalc } from './adjustmentHelper';
